import { useEffect, useRef, useState } from "react";
import { SignaturePadAtom } from "../../../../components/atoms/SignaturePadAtom"

type Props = {
    confirm?: (value: string | null) => void;
    confirmLabel?: string;
}

export const AuthSignatureModal = ({ confirm, confirmLabel }: Props) => {
    const padRef = useRef<{clear: () => void;}>(null);
    const [sign, setSign] = useState<string | null>(null);

    const _handleAuth = () => {
        if(!confirm)
            return;
        confirm(sign);
    }
    
    return (
        <div className="d-flex justify-content-center">
            <div style={{ width: 500 }}>
                <SignaturePadAtom ref={padRef}  onChange={setSign}/>
                <div className="d-flex flex-row gap-2 flex-wrap justify-content-between">
                    <button className="btn btn-light" onClick={() => padRef.current?.clear()}>
                        Clear
                    </button>
                    <button className="btn btn-success" disabled={!sign?.length} onClick={_handleAuth}>
                        { confirmLabel ?? 'Authorize' }
                    </button>
                </div>
            </div>
        </div>
    )
}